/**
 * Array for all the different actions that can be taken.  If a field has a value of 'null', then we know that it is a
 * mandatory field. Likewise, if a field has a value of 'default', then it is an optional field that will just use the default
 * value instead of the value passed in if it is not included.
 */
class SyncTemplates  {
    static session(sessionStart)  {
        return {
            onboardingStatus: {
                modifiedDate: null,
                statusName: null,
                previousStatus: null
            },
            sessionStart: sessionStart,
            faceProcessorStarted: false,
            reliableConnectionToGhost: true,
            voiceChatActive: false,
            proctorReviewComplete: {
                result: 'waiting',
                reason: null
            },
            extensionActions: [],
            onboardingActions: [],
            sessionActions: [],
            currentModalityOptions: [],
            recording_started: null,
            syncDocCreationDate: new Date().getTime(),
            forceQuit: false,
            sessionEnded: false
        }
    }
}

module.exports = SyncTemplates;
